import {Positionable} from "../../core/reel/simplereel/SimpleReelModel";
import {DevilsCrossRoadFreespinReel} from "./DevilsCrossRoadFreespinReel";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadGameAssets} from "../DevilsCrossRoadGameAssets";
import {gsap} from "gsap";
import {DevilsCrossRoadSymbolState} from "../symbol/DevilsCrossRoadSymbolConfig";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {DevilsCrossRoadGameConfig} from "../DevilsCrossRoadGameConfig";


export class FreespinSymbol extends PIXI.Container implements Positionable {

    private symbolName:string;
    private _overlay:PIXI.Sprite;
    private _spinSprite:PIXI.Sprite = new PIXI.Sprite();
    private view:PIXI.Container;
    public valueInt:number = -1;

    private mainSprite:PIXI.Sprite;
    private fSymbolLabel:PIXI.BitmapText;
    private _stateAnimation:gsap.core.Timeline;
    private reelsView:DevilsCrossRoadFreespinReel;
    public isCollected:boolean = false;

    private state:DevilsCrossRoadSymbolState;
    private valueLabel:PIXI.BitmapText;
    private blinkLabel:PIXI.BitmapText;

    private coinHighlightAnimActiveLoopR: TimelineSprite;
    private coinHighlightRadial: TimelineSprite;



    constructor(symbolName:string, initState:DevilsCrossRoadSymbolState, reelsView:DevilsCrossRoadFreespinReel, goatTease:boolean = false) {
        super();

        this.reelsView = reelsView;
        this.symbolName = symbolName;

        this._overlay = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("C", "_highlight"))[0]);
        this._overlay.tint = 0xffffff;
        this._overlay.alpha = 0;
        //this._overlay.scale.set(0.9, 0.9);
        let coin:boolean = false;
        const stateName:string = "";

        if(this.symbolName.indexOf("F") > -1) {
            //this.createMockFxSymbol();
            this.mainSprite = new PIXI.Sprite();
        }
        else {
            this.mainSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath(this.symbolName, stateName))[0]);
            coin = (this.symbolName !== "X");
            this.mainSprite.name = "stateName: " + stateName;
        }
        //this.mainSprite.anchor.set(0.5, 0.5);

        this.view = new PIXI.Container();
        this.view.addChild(this.mainSprite);
        if(coin) {
            this.view.addChild(this._overlay);
        }



        this.addChild(this.view);

        if (this.symbolName === "CX" && goatTease) {
            const stateNameT: string = (this.symbolName === "CX" && goatTease) ? "_spin" : "";
            this._spinSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("X", stateNameT))[0]);
        }
        this.getStateAnimation(initState, goatTease);
        this.view.position.set(15, 7.5);
    }

    public resetToX() {
        this.mainSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("X"))[0]);
        this._spinSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("X"))[0]);
    }

    public resetTextures():void {
        this.symbolName = "X";

        this._overlay = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("X"))[0]);
        this._overlay.tint = 0xffffff;
        this._overlay.alpha = 0;
        //this._overlay.scale.set(0.9, 0.9);
        let coin:boolean = false;

        if(this.symbolName.indexOf("F") > -1) {
            //this.createMockFxSymbol();
            this.mainSprite = new PIXI.Sprite();
        }
        else {
            const stateName:string = "";
            this.mainSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("X", stateName))[0]);
            if(this._spinSprite) {
                this._spinSprite.destroy();
            }
            this._spinSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath("X", stateName))[0]);
        }
        //this.mainSprite.anchor.set(0.5, 0.5);

        this.view.destroy();
        this.view = new PIXI.Container();
        this.view.addChild(this.mainSprite);


        this.addChild(this.view);
        this.getStateAnimation(DevilsCrossRoadSymbolState.NO_WIN);
        this.view.position.set(15, 7.5);
    }

    public getValue():number {
        if(this.valueLabel) {
            return Number(this.valueLabel.text);
        }
        else {
            return -1;
        }
    }

    public show(): void {
        this.view.visible = true;
    }

    public hide(): void {
        this.view.visible = false;
    }

    public addAndShowValueLabel(value:string, animate:boolean = true): void {

        if(this.valueLabel) {
            this.valueLabel.text = "";
        }

        if(this.blinkLabel) {
            this.blinkLabel.text = "";
        }

        this.valueLabel = new PIXI.BitmapText(value, {
            fontName : DevilsCrossRoadGameAssets.BITMAP_FONT_NUMBERS_COIN,
            fontSize : 36
        });
        this.blinkLabel = new PIXI.BitmapText(value, {
            fontName : DevilsCrossRoadGameAssets.BITMAP_FONT_NUMBERS_COIN_GLOW,
            fontSize : 36
        });
        this.blinkLabel.anchor = 0.5;
        this.valueLabel.anchor = 0.5;
        this.valueLabel.position.set((this.view.width/2), (this.view.height/2));
        this.blinkLabel.position.set((this.view.width/2), (this.view.height/2));
        this.blinkLabel.alpha = 0;
        //this.valueLabel.anchor.set(0.5, 0.5);
        this.valueInt = Number(value);

        if(this.state === DevilsCrossRoadSymbolState.SPIN) {
            const stateName:string = (["X", "C", "CX"].indexOf(this.symbolName) > -1)?  "_spin" : "";
            this._spinSprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures(DevilsCrossRoadGameAssets.getSymbolStateTexturePath(this.symbolName, stateName))[0]);
        }

        this.view.addChild(this._spinSprite);
        this.view.addChild(this.valueLabel);
        this.view.addChild(this.blinkLabel);

        if(animate) {
            const tl:gsap.core.Timeline = gsap.timeline({yoyo: true, repeat: 1});

            /*tl.add([
                gsap.fromTo(this.blinkLabel, 0.03, {
                    ease : "power3.out",
                    alpha  : 0
                }, {
                    alpha : 1
                })
            ], 0);*/
            tl.add([
                gsap.fromTo(this.valueLabel.scale, 0.1, {
                    ease : "power3.out",
                    y: 1,
                    x: 1

                }, {
                    y: 1.2,
                    x: 1.2
                }),
                gsap.fromTo(this.blinkLabel.scale, 0.1, {
                    ease : "power3.out",
                    y: 1,
                    x: 1
                }, {
                    y: 1.2,
                    x: 1.2
                })
            ]);
            /*const tl2 :gsap.core.Timeline = gsap.timeline();
            tl2.add([
                gsap.fromTo(this.blinkLabel, 0.03, {
                    ease : "power3.out",
                    alpha  : 1
                }, {
                    alpha : 0
                })
            ], 0.15);*/
        }
    }

    public blinkText(doIt:boolean = false):void{
        const tl:gsap.core.Timeline = gsap.timeline();

        if(!doIt) {
            tl.add(() => {
                this.playCoinHighlight()
            });
        }
        tl.add(gsap.fromTo(this._overlay, 0.2, {alpha: 0, yoyo: true}, {alpha: (doIt)? 1 : 0})).add(() => {
            this._overlay.alpha = 0;
        });
    }

    public playCoinHighlightLoop(): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        const coinHighlightAnim:TimelineSprite = new TimelineSprite(DevilsCrossRoad.assetLoader.getTextures("coin_highlight"));
        coinHighlightAnim.scale.set(0.9, 0.9);
        coinHighlightAnim.blendMode = PIXI.BLEND_MODES.ADD;
        coinHighlightAnim.visible = false;
        coinHighlightAnim.anchor.set(0.08, 0.125);

        this.addChild(coinHighlightAnim);

        tl.add(() => {
            coinHighlightAnim.visible = true;
        });
        tl.add(() => {
            coinHighlightAnim.playLoop();
        });

        this.coinHighlightAnimActiveLoopR = coinHighlightAnim;

        return tl;
    }

    public fadeCoinHighlightLoopAndStop(): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(this.coinHighlightAnimActiveLoopR) {
            tl.add(gsap.fromTo(this.coinHighlightAnimActiveLoopR, 0.2, {alpha: 1}, {alpha: 0}));
            tl.add(() => {
                this.coinHighlightAnimActiveLoopR.visible = false;
                this.coinHighlightAnimActiveLoopR.alpha = 1;
                this.coinHighlightAnimActiveLoopR.stopLoop();
            });
        }


        return tl;
    }

    public playCoinHighlight(blink:boolean = false): void {
        if(blink) {
            this.blinkText(true);
        }
        else {
            const coinHighlightAnim: TimelineSprite = new TimelineSprite(DevilsCrossRoad.assetLoader.getTextures("coin_highlight"));
            coinHighlightAnim.scale.set(0.9, 0.9);
            coinHighlightAnim.blendMode = PIXI.BLEND_MODES.ADD;
            coinHighlightAnim.visible = false;
            coinHighlightAnim.anchor.set(0.08, 0.125);

            this.addChild(coinHighlightAnim);
            coinHighlightAnim.getAnimationAutoShowHide();
        }
    }

    public playCoinHighlightRadial(): void {
        const coinHighlightRadialAnim:TimelineSprite = new TimelineSprite(DevilsCrossRoad.assetLoader.getTextures("coin_highlight_r"));
        coinHighlightRadialAnim.scale.set(0.9, 0.9);
        coinHighlightRadialAnim.blendMode = PIXI.BLEND_MODES.ADD;
        coinHighlightRadialAnim.visible = false;
        coinHighlightRadialAnim.anchor.set(0.08, 0.125);

        this.addChild(coinHighlightRadialAnim);
        coinHighlightRadialAnim.getAnimationAutoShowHide();
    }

    public blinkAndUpdateValue(newVal:number, skipVal:boolean = false, blink:boolean = false): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        this.valueInt = newVal;

        tl.add(() => {
            this.playCoinHighlight(blink);
        });
        tl.add(gsap.fromTo(this._overlay, 0.2, {alpha: 0, yoyo: true}, {alpha: 0})).add(() => {
            if(!skipVal) {
                this.addAndShowValueLabel(newVal.toString());
            }
            this._overlay.alpha = 0;
        });
        return tl;
    }

    public getStateAnimation(state:DevilsCrossRoadSymbolState, goatTease:boolean = false):gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this._stateAnimation = tl;

        if(state === DevilsCrossRoadSymbolState.LANDING && (this.symbolName === "C" || this.symbolName === "CX")) {
            tl.add(() => {
                this._spinSprite.visible = false;
                this.blinkText(true);
                this.playCoinLandSound(this.valueLabel.text);
                DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.data.freespinsLeft);
                DevilsCrossRoad.freespinUnlockAreas.setIndicator(DevilsCrossRoad.model.data.freespinsLeft);
            });
           /* const tl2:gsap.core.Timeline = gsap.timeline({yoyo: true, repeat: 1});

            tl2.add([
                gsap.fromTo(this.valueLabel.scale, 0.1, {
                    ease : "power3.out",
                    y: 1,
                    x: 1

                }, {
                    y: 1.2,
                    x: 1.2
                }),
                gsap.fromTo(this.blinkLabel.scale, 0.1, {
                    ease : "power3.out",
                    y: 1,
                    x: 1
                }, {
                    y: 1.2,
                    x: 1.2
                })
            ]);*/
        }
        if(state === DevilsCrossRoadSymbolState.LANDING && (this.symbolName === "X")) {
            this._spinSprite.visible = false;
            this.checkLastReelSound(this.reelsView.id);
            DevilsCrossRoadSound.playBonsuSymEmptyLandingSound(this.reelsView.id);
        }

        return this._stateAnimation
    }

    private playCoinLandSound(coinVal: string): void {
        if (this.symbolName === "C") {
            if (coinVal === "1") {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_LAND1});
            } else if (coinVal === "5") {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_LAND5});
            } else if (coinVal === "20") {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_LAND20});
            } else if (coinVal === "100") {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_LAND100});
            }
            this.checkLastReelSound(this.reelsView.id);
            if (this.checkLineFilled()) {
                if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_ROW_FILLED)?.isPlaying) {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_ROW_FILLED});
                }
            }
        }
    }

    public checkLineFilled(): boolean {
        let isLineFilled: boolean = false;
        let currentReel: number = Math.floor(this.reelsView.id / 6);
        let currentRow: number = this.reelsView.id % 6;
        if (DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.FREESPIN) {
            if (this.checkSameColumn(currentReel,currentRow)) {
                isLineFilled = true;
            }
        } else if (DevilsCrossRoad.model.data.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
            if (this.checkSameColumn(currentReel,currentRow) || this.checkSameRow(currentReel,currentRow)) {
                isLineFilled = true;
            }
        }
        return isLineFilled;
    }

    private checkSameColumn(reelNo:number,rowNo:number): boolean {
        return (DevilsCrossRoad.model.data.previousStickyCoins[reelNo].indexOf("X") > -1) && (DevilsCrossRoad.model.data.stickyCoins[reelNo].indexOf("X") === -1) && (this.lastCoinLandedOnColumn(reelNo,rowNo));

    }

    private checkSameRow(reelNo:number,rowNo:number): boolean {
        return ((DevilsCrossRoad.model.data.previousStickyCoins.some((item: string[]) => item[rowNo] === "X")) && (DevilsCrossRoad.model.data.stickyCoins.every((item: string[]) => item[rowNo] !== "X")) && this.lastCoinLandedOnRow(reelNo,rowNo))

    }

    private lastCoinLandedOnColumn(reelID:number,rowID:number): boolean {
        let arrayPosition: number[] = [];
        DevilsCrossRoad.model.data.previousStickyCoins[reelID].forEach((item: string, index: number) => {
            if ((item === "X") && (DevilsCrossRoad.model.data.stickyCoins[reelID][index] !== "X")) {
                arrayPosition.push(index);
            }
        });
        return arrayPosition.every((item: number) => rowID >= item);
    }

    private lastCoinLandedOnRow(reelNo:number,rowNo:number):boolean{
        let arrayPos: number[] = [];
        DevilsCrossRoad.model.data.previousStickyCoins.forEach((item: string[], index: number) => {
            if ((item[rowNo] === "X") && (DevilsCrossRoad.model.data.stickyCoins[index][rowNo] !== "X")) {
                arrayPos.push(index);
            }
        });
        return arrayPos.every((item: number) => reelNo >= item);
    }
    public checkLastReelSound(id: number): void {
        let reelId: number = Math.floor(id / 6);
        let rowId: number = id % 6;

        let lastSymID: number | null = this.checkOneReelLastSpinningSymbol(reelId);

        if (lastSymID !== null) {
            if (lastSymID === rowId) {
                if (!DevilsCrossRoadGameConfig.FS_PLAYED_REEL_LAND_SOUND[reelId]) {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_REEL_LAND.next()});
                    DevilsCrossRoadGameConfig.FS_PLAYED_REEL_LAND_SOUND[reelId] = true;
                }
            }
        }
    }

    private checkOneReelLastSpinningSymbol(reelNo: number): number | null {
        let symNo: number | null = null;
        for (let i: number = DevilsCrossRoad.model.data.previousStickyCoins[reelNo].length - 1; i >= 0; i--) {
            if (DevilsCrossRoad.model.data.previousStickyCoins[reelNo][i] === "X") {
                return i;
            }
        }
        return symNo;
    }
}